import { configuredByLabelOptions } from 'features/cluster/workload-optimization/_constants';

import { configuredViaCriterion } from '../../../../searchCriteria';

import { QuickSearchFilter } from '@cast/shared-search-ui';

export const ConfiguredViaQuickSearch = () => {
  return (
    <QuickSearchFilter
      options={configuredByLabelOptions}
      criterion={configuredViaCriterion}
      multiple
    />
  );
};
